<template>
  <div class="px-4 md:px-6 lg:px-8 py-6">
    <BaseCard class="mx-auto mt-6 max-w-screen-2xl">
      <BaseCalendar :events="events" @change-date="setDate" @click-event="handleEventClick"/>
    </BaseCard>
    <CandidateInterviewModal v-if="selectedInterviewId"
                             :interview-id="selectedInterviewId"
                             @close="selectedInterviewId = null"
                             @interview-cancelled="handleCancelInterview"/>
  </div>
</template>

<script setup>
import BaseCard from "../components/BaseCard.vue";
import BaseCalendar from "../components/BaseCalendar.vue";
import CandidateInterviewModal from "../components/CandidateInterviewModal.vue";
import CandidateInterviewScheduleApi from "../api/CandidateInterviewScheduleApi.js";
import {onMounted, ref} from "vue";

const events = ref([]);
const selectedInterviewId = ref();
const lastFetchedStart = ref(null);
const lastFetchedEnd = ref(null);

function getCurrentUserInterviewEvents(start, end) {
  // Minimize API calls by only getting events when the scope of our range changes
  if (start === lastFetchedStart.value && end === lastFetchedEnd.value) return;
  if (start >= lastFetchedStart.value && end <= lastFetchedEnd.value) return;
  lastFetchedStart.value = start;
  lastFetchedEnd.value = end;

  new CandidateInterviewScheduleApi()
    .index({start: start, end: end})
    .then(response => {
      events.value = response.data.map(interview => {
        return {
          id: interview.id,
          title: interview.company_name,
          start: interview.start_time,
          duration: interview.duration,
          url: `/company-interviews/${interview.uuid}`,
        };
      });
    });
}

const handleCancelInterview = (id) => events.value = events.value.filter(event => event.id !== id);

const handleQueryParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const interviewId = urlParams.get("interview");
  if (interviewId && /^\d+$/.test(interviewId)) selectedInterviewId.value = parseInt(interviewId);
};

const handleEventClick = (id) => selectedInterviewId.value = id;

const setDate = (info) => getCurrentUserInterviewEvents(info.start, info.end);

onMounted(() => handleQueryParams());
</script>

<style>
:root {
  --fc-today-bg-color: #ebf3ff;
}
</style>
